var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "app-company-info-wrapper",
    { attrs: { company: _vm.value, "no-scroll": "" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c("w-input", {
            attrs: { "icon-left": "search" },
            model: {
              value: _vm.searchInput,
              callback: function ($$v) {
                _vm.searchInput = $$v
              },
              expression: "searchInput",
            },
          }),
        ],
        1
      ),
      _c(
        "w-button-bar",
        { attrs: { slot: "actions" }, slot: "actions" },
        [
          _c(
            "w-button",
            {
              directives: [
                {
                  name: "tooltip",
                  rawName: "v-tooltip",
                  value: _vm.showModuleInfoToolTip,
                  expression: "showModuleInfoToolTip",
                },
              ],
              attrs: { disabled: _vm.notAllowedToView },
              on: {
                click: function ($event) {
                  return _vm.showModuleInfo()
                },
              },
            },
            [_c("w-fa", { attrs: { icon: "eye" } })],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        { attrs: { grow: "", shrink: "" } },
        [
          _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-data-table", {
                staticStyle: { "flex-grow": "1", "flex-shrink": "1" },
                attrs: {
                  columns: _vm.columns,
                  items: _vm.sortedModules,
                  "selected-items": _vm.selectedRows,
                },
                on: {
                  "item-clicked": function ($event) {
                    return _vm.showModuleInfo($event)
                  },
                  order: function ($event) {
                    return _vm.onOrder($event)
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.toShowModule != null } },
        [
          _vm.toShowModule
            ? _c("app-company-info-module-meta-data", {
                attrs: { value: _vm.toShowModule, company: _vm.value },
                on: {
                  close: function ($event) {
                    return _vm.closeShowModule()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }